<template lang="pug">
  .link.deleted(v-if='sharedObject.kind == "deleted"', @click.stop="$emit('click')") 
    i.fa.fa-trash
    .description Cet objet a été supprimé

  //- event
  .link.event(v-else-if='sharedObject.kind == "event"', @click.stop="$emit('click')")
    vue-object-img(:object='sharedObject.group')
    i.fa.fa-calendar-o
    .date {{sharedObject.startTime | unixtimeTo('llll') | ucfirst }}
    .address {{sharedObject.name}} 
      i
        small {{sharedObject | address }} &nbsp;

  //- file
  .link.file(v-else-if='sharedObject.kind == "file"', @click.stop="$emit('click')") 
    vue-object-img(:object='sharedObject.group')

    //- icons or image
    template
      //- image
      image-thumb(v-if='nodeIsImage(sharedObject)', :src='downloadLink(sharedObject, 2)')
      //- youtube
      image-thumb.youtube(v-if='nodeIsYoutubeLink(sharedObject)', :src='getNodeYoutubeImageLink(sharedObject)')
      i.fa.fa-youtube-play.playOverVideo(v-if='nodeIsYoutubeLink(sharedObject)')
      //- other
      i.fa(:class='sharedObject | nodeIconClass' v-if='hasNotPreviewImage(sharedObject)')
    .date {{sharedObject.creationDate | unixtimeTo('llll') | ucfirst }}
    .address {{ hrS(sharedObject.size) }}

  //- poll
  .link.poll(v-else-if='sharedObject.kind == "poll"', @click.stop="$emit('click')") 
    vue-object-img(:object='sharedObject.group')
    i.fa.fa-tasks
    .date {{sharedObject.startTime | unixtimeTo('llll') | ucfirst }}
    .date &gt; {{sharedObject.endTime | unixtimeTo('llll') | ucfirst }}
</template>
<script type="text/javascript">
import VueObjectImg from '@/components/shared/VueObjectImg'
import ImageThumb from '@/components/shared/ImageThumb'

import {users, unixtimeTo, ucfirst, address} from '@/components/shared/vue.globals'

import NodeMixin from '@/components/shared/NodeMixin'

export default {
  props: {
    sharedObject: {
      required: true
    }
  },
  components: {
    VueObjectImg,
    ImageThumb
  },
  mixins: [NodeMixin],
  filters: {
    users,
    unixtimeTo,
    ucfirst,
    address
  }
}
</script>
<style lang="sass">
.link
  padding: 10px
  transition: background-color 0.5s ease
  white-space: nowrap
  padding-right: 30px
  position: relative
  & > *:not(i):not(.profileImage):not(img)
    line-height: 20px
    padding-left: 60px
    padding-right: 40px
    width: 100%
    overflow: hidden
    text-overflow: ellipsis
  & > i
    margin-left: 0px
    position: absolute
    font-size: 50px
    left: 10px
    top: 5px
  .profileImage
    position: absolute
    line-height: 50px
    height: 50px
    width: 50px
    right: 10px
    top: 5px
  &.event
    .date
      position: relative
    .address
      position: relative
  &.file
    & > img.thumb
      padding: 0
      max-height: 50px
      max-width: 50px  
      position: absolute
      box-shadow: 0px 0px 5px rgba(0,0,0, 0.5)
    .playOverVideo
      font-size: 20px
      top: 15px
      left: 25px
      color: white
  &.deleted
    & > i
      font-size: 25px
      margin-left: 10px
      margin-top: 2px
</style>



// WEBPACK FOOTER //
// SharedObjectAbstract.vue?7a1948e0